import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11 * (props.wx ?? 1)}
    height={35 * (props.hx ?? 1)}
    viewBox="0 0 11 35"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.442 23.299c.058-.392.162-.881.333-1.356.248-.684.48-1.37.583-2.089.207-1.442.51-3.063.78-4.93.371-2.58.675-5.635 1.145-9.345C4.622 2.908 5.501 1 6.114 1c.647 0 .827 1.458 1.083 4.426.514 5.972 1.117 10.908 1.5 14.19.12 1.03.31 2.05.677 3.02.185.49.301.952.357 1.29.426 2.572.343 6.354.105 8.619-.063.594-.36.856-1.313.98-2.07.27-4.992.207-6.512.045-.682-.073-1.016-.415-1.01-1.313.01-1.645.113-6.757.44-8.958"
    />
  </svg>
);
export default SvgNormal;
